import { CopyOutlined, CopyTwoTone } from "@ant-design/icons";
import { Typography } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { formatLongId } from "utils/formatLongId.ts";

const { Text } = Typography;

interface ShortenedTextWithCopyProps {
    id?: string;
    charactersBetweenDots?: number;
}

/**
 * Functional component that displays a shortened version of a given ID and provides a copy-to-clipboard feature.
 */
export const ShortenedIdWithCopy: FC<ShortenedTextWithCopyProps> = ({ id, charactersBetweenDots }) => {
    const { t } = usePaldockTranslation("common");
    const idWithEllipsis = formatLongId(id, charactersBetweenDots ?? 4);

    if (!idWithEllipsis) {
        return <>-</>;
    }

    return (
        <Text
            copyable={{
                text: id,
                icon: [<CopyOutlined key={"copyOutlined"} />, <CopyTwoTone key={"copyTwoTone"} />],
                tooltips: [t("copy_tooltips.click_to_copy"), t("copy_tooltips.copied")],
            }}
            className="w-full flex justify-between items-center"
        >
            {idWithEllipsis}
        </Text>
    );
};
